import { SnippetTextarea } from '@/components/common/SnippetTextarea.js';

export function TicketNoteComposer({
  value,
  onChange,
  onSubmit,
  submitting,
  placeholder = 'Write a note… type / to insert a snippet',
  submitLabel = 'Save Note',
  visibility,
  onVisibilityChange,
}: {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  submitting?: boolean;
  placeholder?: string;
  submitLabel?: string;
  visibility?: 'public' | 'private';
  onVisibilityChange?: (visibility: 'public' | 'private') => void;
}) {
  return (
    <div>
      {onVisibilityChange ? (
        <div className="mb-3 grid grid-cols-2 gap-2">
          {(['private', 'public'] as const).map((mode) => (
            <button
              key={mode}
              type="button"
              className={[
                'min-h-[44px] rounded-xl px-3 text-sm font-semibold',
                visibility === mode ? 'bg-primary text-white' : 'bg-slate-100 text-slate-700',
              ].join(' ')}
              onClick={() => onVisibilityChange(mode)}
            >
              {mode === 'private' ? 'Private' : 'Public'}
            </button>
          ))}
        </div>
      ) : null}
      <SnippetTextarea value={value} onChange={onChange} placeholder={placeholder} />
      <div className="mt-3 flex justify-end">
        <button
          type="button"
          disabled={submitting || !value.trim()}
          className="min-h-[44px] rounded-xl bg-primary px-4 py-2 text-sm font-semibold text-white disabled:opacity-50"
          onClick={onSubmit}
        >
          {submitLabel}
        </button>
      </div>
    </div>
  );
}
